import { Button, Flex, Form, Modal } from "antd";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomTitle } from "../../../../../common/customTitle";
import { t } from "i18next";
import TextArea from "antd/es/input/TextArea";
import { sanitizeDataTypeClientSide } from "../../../../../../utils/utils";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { updateServiceProviderStatusAction } from "../../../../../../redux/services/service-providers/serviceProvidersServices";

const AcceptRejectStatusDialog = ({ open, onClose, status }) => {
  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* id dependencies */
  const { selectedServiceProvider } = useSelector(
    (state) => state.serviceProviders
  );

  /* id dependencies */

  const { selectedServiceProviderId } = selectedServiceProvider;

  /* initial dependencies */
  useEffect(() => {
    if (
      !selectedServiceProviderId ||
      selectedServiceProviderId === "" ||
      selectedServiceProviderId === null ||
      selectedServiceProviderId === undefined
    ) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedServiceProviderId]);
  /* initial dependencies */

  /* dialog close dependencies */
  const handleDialogClose = () => {
    onClose();
    form.resetFields();
  };
  /* dialog close dependencies */

  /* on submit action */
  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      status: status === "isAccepted" ? "accepted" : "rejected",
      selectedServiceProviderId,
    };
    dispatch(updateServiceProviderStatusAction(dataToBeSent, setLoading)).then(() => {
      handleDialogClose();
    });
  };
  /* on submit action */

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="2rem">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {status === "isAccepted" ? "Accept" : "Reject"}
        </CustomTitle>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Form.Item
            label={
              <RequiredLabel
                text={t("Modules.ServiceProviderAuth.remarks")}
                required={true}
              />
            }
            name="verification_remark"
            normalize={(value) => sanitizeDataTypeClientSide(value)}
            rules={[
              {
                required: true,
                message: t("Modules.ServiceProviderAuth.pleaseEnterRemarks"),
              },
              {
                whitespace: true,
                message: t("Modules.ServiceProviderAuth.pleaseEnterRemarks"),
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Flex justify="center" align="center">
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              {t("CommonUtils.submit")}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </Modal>
  );
};

export default AcceptRejectStatusDialog;
